"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataDogRUMProvider = exports.useDataDogRUM = exports.DataDogRUMContext = void 0;

var react_1 = __importDefault(require("react"));

var browser_rum_1 = require("@datadog/browser-rum");

var browser_core_1 = require("@datadog/browser-core");

exports.DataDogRUMContext = react_1.default.createContext(null);

function useDataDogRUM() {
  var datadogRum = react_1.default.useContext(exports.DataDogRUMContext);

  if (!datadogRum) {
    throw new Error('useDataDogRUM must be used within a DataDogRUMContext');
  }

  var dd = datadogRum;

  function addRumGlobalContext(key, value) {
    dd.addRumGlobalContext(key, value);
  }

  function addUserAction(key, value) {
    dd.addUserAction(key, value);
  }

  function addError(error, context, source) {
    if (source === void 0) {
      source = browser_core_1.ErrorSource.CUSTOM;
    }

    dd.addError(error, context, source);
  }

  return {
    addRumGlobalContext: addRumGlobalContext,
    addUserAction: addUserAction,
    addError: addError
  };
}

exports.useDataDogRUM = useDataDogRUM;

function DataDogRUMProvider(props) {
  var _a = props.trackInteractions,
      trackInteractions = _a === void 0 ? false : _a,
      _b = props.resourceSampleRate,
      resourceSampleRate = _b === void 0 ? 0 : _b,
      _c = props.sampleRate,
      sampleRate = _c === void 0 ? 0 : _c,
      globalContextParams = props.globalContextParams,
      children = props.children,
      rest = __rest(props, ["trackInteractions", "resourceSampleRate", "sampleRate", "globalContextParams", "children"]);

  browser_rum_1.datadogRum.init(__assign({
    trackInteractions: trackInteractions,
    resourceSampleRate: resourceSampleRate,
    sampleRate: sampleRate
  }, rest));

  if (globalContextParams) {
    // @ts-ignore
    Object.keys(globalContextParams).forEach(function (key) {
      // @ts-ignore
      return datadogRum.addRumGlobalContext(key, globalContextParams[key]);
    });
  } // If we'd like to add custom page/health metrics listeners - that's the right place to do it.


  return react_1.default.createElement(exports.DataDogRUMContext.Provider, {
    value: browser_rum_1.datadogRum
  }, children);
}

exports.DataDogRUMProvider = DataDogRUMProvider;